import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/5f29dc48-9590-4b13-ae7e-f0353c3fcc43.png"
              alt="Logo"
              className="h-9 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm text-slate-400 leading-relaxed">
              Dinamik QR kodlarınızı oluşturun, özelleştirin ve tarama istatistiklerini gerçek zamanlı takip edin.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-linkedin-line", "ri-facebook-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-800 hover:bg-emerald-500 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Ürün</h4>
            <ul className="space-y-2.5">
              {[
                { label: "QR Oluşturucu", path: "/generator" },
                { label: "İndirme Seçenekleri", path: "/download" },
                { label: "İstatistikler", path: "/statistics" },
                { label: "Fiyatlandırma", path: "/pricing" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="text-sm text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Destek</h4>
            <ul className="space-y-2.5">
              {["SSS", "Yardım Merkezi", "İletişim", "Gizlilik Politikası"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-slate-400 hover:text-blue-400 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Bülten</h4>
            <p className="text-sm text-slate-400 mb-4">Yeni özellikler ve güncellemelerden haberdar olun.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors"
              />
              <button className="px-3 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors cursor-pointer">
                <i className="ri-send-plane-line text-white text-sm"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© 2026 QR Generator. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-slate-500 hover:text-gray-300 transition-colors cursor-pointer">Gizlilik Politikası</a>
            <a href="#" className="text-xs text-slate-500 hover:text-gray-300 transition-colors cursor-pointer">Kullanım Şartları</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
